import { render } from "./addRec.vue?vue&type=template&id=1b805bbc&scoped=true"
import script from "./addRec.vue?vue&type=script&lang=js"
export * from "./addRec.vue?vue&type=script&lang=js"

import "./addRec.vue?vue&type=style&index=0&id=1b805bbc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b805bbc"]])

export default __exports__